module.exports = __WEBPACK_EXTERNAL_MODULE_49__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","setMonth"],"commonjs":"date-fns/set_month/index","commonjs2":"date-fns/set_month/index","amd":"date-fns/set_month/index"}
// module id = 49
// module chunks = 0